import type { Node } from '@atlaskit/editor-prosemirror/model';

export type NodeTypeCounts = { [nodeType: string]: number };

export const getNodeTypeCounts = (node: Node, childrenNodeTypeCounts: NodeTypeCounts[]) => {
	const nodeTypeName = node?.type?.name || '';
	return (childrenNodeTypeCounts || []).reduce(
		// Aggregates the nodeTypeCounts of all children of this node.
		(acc, childNodeTypeCounts) => {
			Object.entries(childNodeTypeCounts).forEach(([childNodeTypeName, count]) => {
				acc[childNodeTypeName] = (acc[childNodeTypeName] || 0) + count;
			});
			return acc;
		},
		// Adds 1 for this nodes type to its own nodeTypeCounts.
		{ [nodeTypeName]: 1 },
	);
};
